import React from 'react';

const EmailForm = ({person , onChange , onSave , saving})=>{

    return(
        <form action="" className="email-form ">
            <h1>تواصل معنا</h1>
            <input type="text"
             className="name"
             name="name"
             placeholder="الأسم"
             value={person.name}
             onChange={onChange}/>
             <label htmlFor=""></label>

            <input type="text"
             className="email"
             name="email"
             placeholder="الأيميل"
             value={person.email}
             onChange={onChange}/>
             <label htmlFor=""></label>

            <input type="text"
             className="phone"
             name="phone"
             placeholder="رقم الهاتف"
             value={person.phone}
             onChange={onChange}/>
             <label htmlFor=""></label>

            <input type="text"
             className="address"
             name="address"
             placeholder="العنوان"
             value={person.adress}
             onChange={onChange}/>
             <label htmlFor=""></label>

            <input type="text"
             className="subject"
             name="subject"
             placeholder="الموضوع"
             value={person.subject}
             onChange={onChange}/>
             <label htmlFor=""></label>

            <textarea type="text"
             className="message"
             name="message"
             placeholder="الرسالة"
             value={person.message}
             onChange={onChange}/>
             <label htmlFor=""></label>

            <input type="submit"
             className="submit"
             value={saving?"إرسال ...":"إرسال"}
             disabled={saving}
             onClick={onSave}/>                        
        </form>
    );
}
export default EmailForm; 


// WEBPACK FOOTER //
// ./src/components/contact/EmailForm.js